import React, { memo, useMemo } from 'react';
import { Typography } from '@surveycake/rc';
import { Tag } from '@surveycake/rc';
import { InputSlider } from '@surveycake/rc';
import { useDigitSlideAnswer } from './hooks';
import { useStyles } from './styles';

function Answer() {
  const {
    min,
    max,
    step,
    unit,
    value,
    onChange,
    setAnswer,
    haveSetAnswerOnce
  } = useDigitSlideAnswer();

  const userHasDragged = value !== min;
  const styles = useStyles();
  const unitEl = useMemo(
    () =>
      unit && (
        <Tag className={styles.unit} color="primary" variant="outlined">
          {unit}
        </Tag>
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unit]
  );

  return (
    <>
      <div className={styles.info}>
        <Typography variant="h6" color="primary">
          {haveSetAnswerOnce || userHasDragged ? value : '?'}
        </Typography>
        {unitEl}
      </div>
      <InputSlider
        className={styles.transform}
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={onChange}
        onAfterChange={setAnswer}
        onClickChange={setAnswer}
      />
      <div className={styles.range}>
        <span className={styles.min}>{min}</span>
        <span className={styles.max}>{max}</span>
      </div>
    </>
  );
}

export default memo(Answer);
